let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("81rBz")).then(() => parcelRequire('8hpAn'));